import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import { AngularMaterialModule } from 'src/app/material.module';
import { CountryComponent } from './country.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClickOutsideModule } from 'ng-click-outside';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

export const baseRoutes: Routes = [
  {
    path: '',
    component: CountryComponent,
    data: {
      title: 'Country'
    }
  }
];

@NgModule({
  imports: [
    CommonModule,FormsModule,ReactiveFormsModule,ClickOutsideModule,
    AngularMaterialModule,MatNativeDateModule,MatAutocompleteModule,
    RouterModule.forChild(baseRoutes),
    NgxMatSelectSearchModule
  ],
  declarations: [CountryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]
})
export class CountryMasterModule { }
